
import { JwtService } from '../jwt.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Injectable} from '@angular/core';

import { Observable } from 'rxjs';

/** Decorator that allows guard using as injector */
@Injectable()
export class AuthGuard implements CanActivate {

  /** Constructor of class AuthGuard  */
  constructor( private auth: JwtService) {
  }
    /** Method that allows or disallows route activating   */
    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // console.log('can activate route', this.auth.loggedIn);
        return this.auth.loggedIn;
    }


}

